import React, { Suspense, lazy } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Nav from "../../components/Nav/Nav";

import "antd/dist/antd.css";

const Home = lazy(() => import("../Home/Home"));
const About = lazy(() => import("../About/About"));

const App = () => (
  <BrowserRouter>
    <Nav />
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Suspense>
  </BrowserRouter>
);

export default App;
